<template>
  <div class="banner" :style="{ 'max-width': bannerConfig.width }">
    <div v-if="bannerConfig.type == '2'" class="video-box">
      <div class="video-mask" style=""></div>
      <video class="video" autoplay="" loop="" muted="" :src="bannerConfig.video">
        <source :src="bannerConfig.video" type="video/mp4">
      </video>
      <div class="typed" v-if="videoDescList.length > 0">
        <vue-typed-js :strings="videoDescList" loop smartBackspace>
          <span class="typing"></span>
        </vue-typed-js>
      </div>
    </div>
    <div v-else>
      <swiper
        ref="mySwiper"
        :options="swiperOptions"
        class="swiper-wrappe carousel"
      >
        <swiper-slide class="swiper-slide" v-for="(b,i) in bannerList" :key="i">
          <a :href="bannerLinksList[index] || '#'"><img :src="b" alt=""/></a>
        </swiper-slide>

        <!-- 分页器 -->
        <div
          v-show="bannerList && bannerList.length > 1"
          class="swiper-pagination swiper-pagination-white"
          slot="pagination"
        ></div>
        <!-- 左右箭头 -->
        <div
          v-show="bannerList && bannerList.length > 1"
          class="swiper-button-prev swiper-button-white"
          slot="button-prev"
        ></div>
        <div
          v-show="bannerList && bannerList.length > 1"
          class="swiper-button-next swiper-button-white"
          slot="button-next"
        ></div>
      </swiper>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    source: {
      type: String,
      default: 'home' //home, sub
    },
  },
  data() {
    return {
      bannerConfig: {},
      bannerList: [],
      bannerLinksList: [],
      videoDescList: [],
      swiperOptions: {
        speed: 800,
        effect: "coverflow", //"fade"（淡入）、"cube"（方块）、"coverflow"（3d流）、"flip"（3d翻转）
        //显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        //设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        //自动轮播
        autoplay: {
          delay: 5000,
          //当用户滑动图片后继续自动轮播
          disableOnInteraction: false,
        },
        //开启循环模式
        loop: true,
      },
    };
  },
  watch: {},
  methods: {},
  created() {
    this.tenantConfig = this.$store.getters.tenantInfo
    if (this.tenantConfig) {
      if(this.source == 'home'){
        this.bannerConfig = this.tenantConfig.json_homeBanner
      }else if(this.source == 'sub'){
        this.bannerConfig = this.tenantConfig.json_subBanner
      }

      if (this.bannerConfig.img) {
        this.bannerList = this.bannerConfig.img.split(",");
      }
      if (this.bannerConfig.links) {
        this.bannerLinksList = this.bannerConfig.links.split("\n");
      }
      if (this.bannerConfig.descs) {
        this.videoDescList = this.bannerConfig.descs.split("\n");
      }
    }
  },
}
</script>

<style lang="less" scoped>
.banner {
  width: 100%;
  margin: auto;
  // max-width: 1200px;
  overflow: hidden;
  // border-radius: 28px;

  .carousel {
    // max-height: 500px;
    // min-height: 250px;
    img {
      width: 100%;
      min-height: 100px;
    }
    .swiper-slide {
      background-position: center;
      background-size: cover;
    }
  }

  // box-shadow: 0 6px 10px rgba(3,3,3,.12156862745098039);
  .video-mask {
    position: absolute;
    width: 100%;
    height: 100%;
    background: linear-gradient(180deg, #5c9bff, #4748ff);
    opacity: .7;
  }

  .typed {
    position: absolute;
    top: 50%;
    width: 100%;

    /deep/.typed-element {
      justify-content: center;

      .typing {
        color: #fff;
        font-size: 2rem;
      }

      .typed-cursor {
        color: #fff;
        font-size: 2rem;
      }
    }
  }

  .img {
    width: 100%;
  }

  .video-box {
    position: relative;
  }

  .video {
    width: 100%;
  }
}
</style>